import { ANC_COMMON_CONSTANTS } from "@constants/ancConstants";
import { dateFormate } from "@constants/index";
import dayjs from "dayjs";

export const ancPeriodDateCalculation = (lmpDate:string, ancNumber:any) => {
  const ancPeriod = {
    startDate: '',
    endDate: ''
  }
  if (ancNumber === 1) {
    ancPeriod.startDate = lmpDate;
    ancPeriod.endDate = dayjs(lmpDate).add(ANC_COMMON_CONSTANTS.ANC_ONE_END_DATE_PERIOD, 'day').format(dateFormate.yyyy_mm_dd);
  }
  else if (ancNumber === 2) {
    ancPeriod.startDate = dayjs(lmpDate).add(ANC_COMMON_CONSTANTS.ANC_TWO_START_DATE_PERIOD, 'day').format(dateFormate.yyyy_mm_dd);
    ancPeriod.endDate = dayjs(lmpDate).add(ANC_COMMON_CONSTANTS.ANC_TWO_END_DATE_PERIOD, 'day').format(dateFormate.yyyy_mm_dd);
  }
  else if (ancNumber === 3) {
    ancPeriod.startDate = dayjs(lmpDate).add(ANC_COMMON_CONSTANTS.ANC_THREE_START_DATE_PERIOD, 'day').format(dateFormate.yyyy_mm_dd);
    ancPeriod.endDate = dayjs(lmpDate).add(ANC_COMMON_CONSTANTS.ANC_THREE_END_DATE_PERIOD, 'day').format(dateFormate.yyyy_mm_dd);
  }
  else if (ancNumber === 4) {
    ancPeriod.startDate = dayjs(lmpDate).add(ANC_COMMON_CONSTANTS.ANC_FOUR_START_DATE_PERIOD, 'day').format(dateFormate.yyyy_mm_dd);
    ancPeriod.endDate = dayjs(lmpDate).add(ANC_COMMON_CONSTANTS.ANC_FOUR_END_DATE_PERIOD, 'day').format(dateFormate.yyyy_mm_dd);
  }
  return ancPeriod;
}
